<div class="project-select">
  <div>
    <a-input
      class="s-input"
      :disabled="true"
      :value="valueName"
      placeholder="请选择"
      @change="inputChange"
    >
    </a-input>
    <a-button type="primary" :disabled="!maintenanceProjectId" class="s-btn" @click="showModal">选择合同</a-button>
  </div>

  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    title="选择合同"
    width="1100px"
    @cancel="closeModal"
    @ok="ok"
  >
    <!-- <a-form layout="inline">
      <a-form-item label="合同类型">
        <a-select
          v-model:value="contractType"
          class="w140"
          placeholder="请选择合同类型"
          @change="contractTypeChange"
        >
          <a-select-option value="0">工程合同</a-select-option>
          <a-select-option value="1">电子签合同</a-select-option>
        </a-select>
      </a-form-item>
    </a-form> -->

    <table-wrapper
      :dataSource="dataSource.records"
      @onTableChange="onTableChange"
      @onRadioChange="onRadioChange"
      :pagination="false"
      :loading="loading"
      :columns="columns"
      :showRadiobox="true"
    >
      <template #type="{record}">
        <span>{{ record.type == "gcht" ? "工程合同" : "电子签合同" }}</span>
      </template>
    </table-wrapper>
    <!-- <table-wrapper
      v-else
      :dataSource="tableData"
      @onTableChange="onTableChange2"
      @onRadioChange="onRadioChange"
      :pagination="paginationSignatures"
      :loading="paginationLoading"
      :columns="columns2"
      :showRadiobox="true"
    >
    </table-wrapper> -->
  </a-modal>
</div>
